import axios from '../../../../axios';
import API from '../../../../actions/api';
import {
  getFavoritesLoading,
  getFavoritesSuccess,
  getFavoritesFailed,
  searchFormsLoading,
  searchFormsSuccess,
  searchFormsFailed,
  addFavoriteLoading,
  addFavoriteSuccess,
  addFavoriteFailed,
  deleteLoading,
  deleteFavoriteSuccess,
  deleteFavoriteFailed,
} from './myFormsSlice';

const BASE_URL = `${API}/favorite-form`;

/**
 * Fetch the current user's favorite forms list.
 */
export const getFavoriteFormsThunk = () => async (dispatch) => {
  try {
    dispatch(getFavoritesLoading());
    const { data } = await axios.get(`${BASE_URL}/`);
    dispatch(getFavoritesSuccess(data));
  } catch (error) {
    dispatch(getFavoritesFailed(error?.message || 'Failed to load favorite forms.'));
  }
};

/**
 * Search for released forms (used by the Search modal).
 * @param {object} params - { organization, form_type, language, description, own_sign, valid_at }
 */
export const searchFormsThunk = (params = {}) => async (dispatch) => {
  try {
    dispatch(searchFormsLoading());
    const query = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([, v]) => v))
    ).toString();
    const { data } = await axios.get(`${BASE_URL}/search/?${query}`);
    dispatch(searchFormsSuccess(data));
  } catch (error) {
    dispatch(searchFormsFailed(error?.message || 'Search failed.'));
  }
};

/**
 * Add one or more forms to favorites.
 * @param {number[]} formIds - Array of form IDs to add.
 */
export const addFavoriteFormsThunk = (formIds) => async (dispatch) => {
  try {
    dispatch(addFavoriteLoading());
    const { data } = await axios.post(`${BASE_URL}/`, { form_ids: formIds });
    dispatch(addFavoriteSuccess(data));
    return data;
  } catch (error) {
    dispatch(addFavoriteFailed(error?.message || 'Failed to add favorite forms.'));
    throw error;
  }
};

/**
 * Bulk-delete favorite forms by their favorite-record IDs.
 * @param {number[]} ids - FavoriteForm record IDs (not form IDs).
 */
export const deleteBulkFavoriteFormsThunk = (ids) => async (dispatch) => {
  try {
    dispatch(deleteLoading());
    await axios.post(`${BASE_URL}/bulk_delete/`, { ids });
    dispatch(deleteFavoriteSuccess(ids));
  } catch (error) {
    dispatch(deleteFavoriteFailed(error?.message || 'Failed to delete favorite forms.'));
    throw error;
  }
};
